import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Solution } from "./components/solution";
import { LeadMagnet } from "./components/LeadMagnet";
import { Pricing } from "./components/Pricing";
import { TechnologyDisclosure } from "./components/technology";
import { HowItWorks } from "./components/HowItWorks";
import CallToAction from "./components/CallToAction";
import FinalReassurance from "./components/FinalReassurance";
import { TransparentSection } from "./components/contact";
import JsonData from "./data/data.json";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Pages
import Login from "./components/Login";
import Signup from "./components/Signup";
import ResetPassword from "./components/ResetPassword";

AOS.init({
  duration: 1000,
  once: true,
  offset: 0,
  startEvent: "DOMContentLoaded",
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const LandingPage = () => (
    <>
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Solution data={landingPageData.Solution} />
      <TechnologyDisclosure data={landingPageData.TechnologyDisclosure} />
      <CallToAction data={landingPageData.CallToAction} />
      <LeadMagnet data={landingPageData.LeadMagnet} />
      <HowItWorks />
      <Pricing data={landingPageData.Pricing} />
      <FinalReassurance data={landingPageData.FinalReassurance} />
    </>
  );

  return (
    <Router>
      {/* Common layout components */}
      <Navigation />

      <div className="main-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          {/* ✅ Keep this route as you wanted */}
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </div>

      <TransparentSection />
    </Router>
  );
};

export default App;
